import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LightCard from "../../../../../../../../components/card/LightCard"
import WhiteCard from "../../../../../../../../components/card/WhiteCard";
import { TxtTitles } from "../../../../../../../../helpers/breadCrumbs";
import dateFormat from "dateformat";
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";
import { getWeekDay } from "../../../../../../../../helpers/weekDay";
import { ListInformationElement } from "./ListInformationElement";
import { Input } from "../../../../../../../../components/ui/Input";
import {Link} from "react-router-dom";
import LordIcon from "../../../../../../../../components/ui/LordIcon";
import {Colors} from "../../../../../../../../components/theme";
import {INITIAL_POPUP} from "../techInfo/techInfoReducer";
import PopupWithContext from "../../../../../../../../components/ui/Popup/PopupWithContext";
import SavingPopupContext from "../../../../../../../../components/ui/Popup/SavingPopupContext";
import OkBtnPopupContext from "../../../../../../../../components/ui/Popup/OkBtnPopupContext";
import AddPersonPopupForm from "./popupForm/AddPersonPopupForm";
import {projectCurrent} from "../../../../../../../../services/api/endpoints";
import useEndpoint from "../../../../../../../../hooks/useEndpiont";
import { produce } from "immer";



export const Events = ({projectId, events, setEvents, pers, usersList}) => {
    const {t} = useTranslation()
    const [persons, setPersons] = useState([])
    const [popup, setPopup] = useState(INITIAL_POPUP)
    const { makeRequest } = useEndpoint();

    useEffect(() => {
        setPersons(pers)
    }, [pers])

    const blurHandler = async (val, fieldName, eventId, personId, instrument) => {
        // tyczy client i estro cost, zapis do db, endpoint => summary-change-event-musician
        const data = { fieldName, value: val, projectId, eventId, musicianId: personId, instrument };
        await makeRequest(
            projectCurrent.summarySaveEventUrl,
            "POST",
            data
        );
    }

    const changeHandler = (val, fieldName, eventId, personId) => {
        // tyczy client i estro cost tylko zmiana stanu
        setEvents(produce(events, draft => {
            const event = draft.find(el => el.id === eventId);
            const musician = event?.musicians.find(el => el.musician_pk === personId);
            if (musician) musician[fieldName] = val;
        }));
    };

    const changeInputHandler = async (val, fieldName, eventId, personId, instrument) => {
        // tyczy absent i lata, zmiana stanu i zapis do db, endpoint => summary-change-event-musician
        const data = { fieldName, value: val, projectId, eventId, musicianId: personId, instrument };
        const result = await makeRequest(
            projectCurrent.summarySaveEventUrl,
            "POST",
            data,
        );
        setEvents(produce(events, draft => {
            const event = draft.find(el => el.id === eventId);
            const musician = event?.musicians.find(el => el.musician_pk === personId);
            if (musician) {
                musician.absent = result.absent
                musician.late = result.late
                musician.client_cost = result.client_cost
                musician.estro_cost = result.estro_cost
            }
        }));
    }

    const getEvent = (event) => {
        const fields = [
            {
                title: <TxtTitles>{t('events.date')}</TxtTitles>,
                content: `${dateFormat(event.eventDate, "dd.mm.yyyy")} (${getWeekDay(dateFormat(event.eventDate, "dd.mm.yyyy"), t)})`,
                widthLimit: '20%'
            },
            {
                title: <TxtTitles>{t('events.start_end')}</TxtTitles>,
                content: `${event.startTime.slice(0, 5)} - ${event.endTime.slice(0, 5)}`,
                widthLimit: '20%'
            },
            {
                title: <TxtTitles>{t('events.type')}</TxtTitles>,
                content: t('project.events.' + event.type),
                widthLimit: '20%'
            },
            {
                title: <TxtTitles>{t('events.composition')}</TxtTitles>,
                content: () => event.composition.map((el, i) => (
                    <React.Fragment key={i}>
                        <span className="me-2">{el.label}</span>
                        {(i + 1) % 3 === 0 && <br />}
                    </React.Fragment>
                )),
                widthLimit: '20%'
            },
            {
                title: <TxtTitles>{t('events.location')}</TxtTitles>,
                content: event.location ? event.location : t('location.to_define'),
                widthLimit: '20%'
            }
        ];
    
        return <ListInformationElement key={event.id} fields={fields} styleMainDiv={{borderBottom:'1px solid black',paddingBottom:'5px'}}/>;
    };

    const musicianTitles = () => {
        const fields = [
            {
                title: '',
                widthLimit: '3%'
            },
            {
                title: <TxtTitles>{t('events.summary.musicians')}</TxtTitles>,
                widthLimit: '23%'
            },
            {
                title: <TxtTitles>{t('events.summary.instrument')}</TxtTitles>,
                widthLimit: '18%'
            },
            {
                title: <TxtTitles>{t('events.summary.late_status')}</TxtTitles>,
                widthLimit: '13%',
                style: { margin: '0 auto', textAlign: 'center' }
            },
            {
                title: <TxtTitles>{t('events.summary.absent_status')}</TxtTitles>,
                widthLimit: '13%',
                style: { margin: '0 auto', textAlign: 'center' }
            },
            {
                title: <TxtTitles>{t('events.summary.client_costs')}</TxtTitles>,
                widthLimit: '15%',
                style: { margin: '0 auto', textAlign: 'center' }
            },
            {
                title: <TxtTitles>{t('events.summary.estro_costs')}</TxtTitles>,
                widthLimit: '15%',
                style: { margin: '0 auto', textAlign: 'center' }
            }
        ];

        return <ListInformationElement fields={fields} />;
    }

    const showMusicianRow = (person, index) => {
        const fields = [
            {
                title: '',
                content: index,
                widthLimit: '3%',
                style: { margin: '0 auto' }
            },
            {
                content: <><span>{person.first_name} {person.last_name}</span></>,
                widthLimit: '23%'
            },
            {
                content: <><span>{person.instrument}</span></>,
                widthLimit: '18%'
            },
            {
                content: <Input
                    type='checkbox'
                    id={"late_"+person.id}
                    checked={person.late}
                    onChange={val => changeInputHandler(val, "late", person.evID, person.id, person.instrument)}
                />,
                widthLimit: '13%',
                style: { margin: '0 auto' }
            },
            {
                content:<Input
                    type='checkbox'
                    checked={person.absent}
                    id={"absent_"+person.id}
                    onChange={val => changeInputHandler(val, "absent", person.evID, person.id, person.instrument)}
                />,
                widthLimit: '13%',
                style: { margin: '0 auto' }
            },
            {
                content: <input
                    type="text"
                    style={{width:'100%', maxWidth:'100px'}}
                    value={person.client_cost}
                    onBlur={val => blurHandler(val.target.value, "client_cost", person.evID, person.id, person.instrument)}
                    onChange={val => changeHandler(val.target.value, "client_cost", person.evID, person.id)}
                />,
                widthLimit: '15%',
                style: { margin: '0 auto' }
            },
            {
                content: <input
                    type="text"
                    style={{width:'100%', maxWidth:'100px'}}
                    value={person.estro_cost}
                    onBlur={val => blurHandler(val.target.value, "estro_cost", person.evID, person.id, person.instrument)}
                    onChange={val => changeHandler(val.target.value, "estro_cost", person.evID, person.id)}
                />,
                widthLimit: '15%',
                style: { margin: '0 auto' }
            }
        ];

        return <ListInformationElement key={person.id} fields={fields} />;
    }

    const summary_event = (event) => {
        const person_filter = persons.filter(el => el.evID === event)
        const sum_late_absent = person_filter.reduce((acc, val) => {
            acc.late += val.late ? 1 : 0
            acc.absent += val.absent ? 1 : 0

            const client = parseFloat(acc.client_cost) + parseFloat(val.client_cost)
            acc.client_cost = client.toFixed(2)
            const estro = parseFloat(acc.estro_cost) + parseFloat(val.estro_cost)
            acc.estro_cost = estro.toFixed(2)
            return acc
        }, {late: 0, absent: 0, client_cost: 0, estro_cost: 0})

        return {...sum_late_absent, count: person_filter.length}
    }

    const popupShow = (action) => {
        if (action === 'addPerson') {
            setPopup({
                formName: action,
                show: true,
                variant: "editF",
                title: t("Add Person"),
                message: "",
                type: "formular",
                leftBtn: t("Add"),
                rightBtn: t("common.button.cancel"),
            })
        }
    }

    const createFooter = (numbers) => {
        const fields = [
            {
                title: '',
                content: '',
                widthLimit: '3%'
            },
            {
                content: 
                    <Link className="addGroup" to={''} onClick={() => popupShow("addPerson")}>
                        <LordIcon url='cross' color={`${Colors.red};`} rotate='45' target='.addGroup'/>
                        <span className="ps-2">{t("common.button.add_person")}</span>
                    </Link>
                ,
                widthLimit: '41%'
            },
            {
                content: `${numbers.late}/${numbers.count}`,
                widthLimit: '13%',
                style: {margin: '0 auto'}
            },
            {
                content: `${numbers.absent}/${numbers.count}`,
                widthLimit: '13%',
                style: {margin: '0 auto'}
            },
            {
                content: `${numbers.client_cost} €`,
                widthLimit: '15%',
                style: { margin: '0 auto' }
            },
            {
                content: `${numbers.estro_cost} €`,
                widthLimit: '15%',
                style: { margin: '0 auto' }
            }
        ];
        return <ListInformationElement fields={fields} styleMainDiv={{borderTop:'1px dashed black',paddingTop:'5px'}}/>;
    }

    const handlePopup = async (opt) => {
        if (popup.formName === "globalSave" && opt.type === 'save') {
            // zapis do bazy
            // const response = await saveTechnicalInfoAPI(params.id, stateCopy)
            // if (response && response.status === 200) {
            //     dispatch({
            //         type: "SET_POPUP",
            //         dataset: {
            //             show: true,
            //             variant: "editF",
            //             title: t("OK"),
            //             message: "Zaktualizowano wpisy w bazie.",
            //             type: "formular",
            //             okBtn: t("common.button.ok"),
            //             formName: "OkBtn",
            //         },
            //         key: "popup"
            //     })
            //     return
            // }
            return
        }

        if (opt.type === 'save') {
            return
        }
        setPopup(INITIAL_POPUP)
    }

    const popupForm = {
        addPerson: <AddPersonPopupForm
            handlePopup={handlePopup}
            usersList={usersList}
            saveBtn={t(popup.leftBtn)}
            cancelBtn={t(popup.rightBtn)}
        />,
        globalSave: <SavingPopupContext
            handlePopup={handlePopup}
            saveBtn={t(popup.leftBtn)}
            cancelBtn={t(popup.rightBtn)}
        />,
        OkBtn: <OkBtnPopupContext okBtn={t(popup.okBtn)} handlePopup={handlePopup} />,
    }

    return (<>
        {popup.show
            ? <PopupWithContext
                variant={popup.variant}
                title={t(popup.title)}
                message={t(popup.message)}
            >
                {popupForm[popup.formName]}
            </PopupWithContext>
        : <>
        <LightCard>
            <RedHeader title={t('project.events_title')} />

            <div className='row px-3'>
                {events.length > 0 &&
                    events.map((event) => (
                        <WhiteCard key={"evCart_"+event.id} classNames='mb-3'>
                            {getEvent(event)}
                            {musicianTitles()}

                            {event.musicians.map((person, person_index) => (
                                showMusicianRow({
                                    evID: event.id,
                                    id: person.musician_pk,
                                    first_name: person.first_name,
                                    last_name: person.last_name,
                                    instrument: person.instrument,
                                    client_cost: parseFloat(person.client_cost).toFixed(2),
                                    estro_cost: parseFloat(person.estro_cost).toFixed(2),
                                    late: person.late,
                                    absent: person.absent,
                                }, person_index+1)
                            ))}

                            {/*{createFooter(summary_event(event.id))}*/}
                        </WhiteCard>
                    ))
                }
            </div>
        </LightCard>
        </>}
    </>);
}


